export const TENANT_HEADER = 'X-Tenant-ID';
export const TENANT_STORAGE_KEY = 'cultivamais:tenant';
